/**
 * Millpoint Axon-style mega menu — click-only L2 drill-down.
 */
(function () {
  const SELECTOR = '[data-millpoint-mega]';

  function initMillpointMega(el) {
    if (el.dataset.millpointInit) return;
    el.dataset.millpointInit = 'true';

    const rootPanels = el.querySelectorAll('[data-millpoint-root-panel]');
    const detailView = el.querySelector('[data-millpoint-detail-view]');
    const detailLinks = el.querySelector('[data-millpoint-detail-links]');
    const detailImageWrap = el.querySelector('[data-millpoint-detail-image]');
    const detailImage = detailImageWrap?.querySelector('img');
    const l2Buttons = el.querySelectorAll('[data-millpoint-l2]');
    const disclosure = el.closest('.main-nav__item--dropdown');

    function showRoot() {
      detailView.hidden = true;
      rootPanels.forEach((panel) => {
        panel.hidden = false;
      });
      el.classList.remove('is-detail-open');
      l2Buttons.forEach((btn) => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    function showDetail(btn) {
      const panelId = btn.dataset.panelId;
      const template = document.getElementById(panelId);
      if (!template) return;

      detailLinks.innerHTML = '';
      detailLinks.appendChild(template.content.cloneNode(true));

      const imageUrl = btn.dataset.image;
      const imageAlt = btn.dataset.imageAlt || '';
      if (detailImage && detailImageWrap) {
        if (imageUrl) {
          detailImage.src = imageUrl;
          detailImage.alt = imageAlt;
          detailImageWrap.hidden = false;
        } else {
          detailImage.removeAttribute('src');
          detailImageWrap.hidden = true;
        }
      }

      l2Buttons.forEach((b) => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-expanded', b === btn ? 'true' : 'false');
      });

      rootPanels.forEach((panel) => {
        panel.hidden = true;
      });
      detailView.hidden = false;
      el.classList.add('is-detail-open');
    }

    l2Buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (e.target.closest('[data-millpoint-l2-close]')) return;
        e.stopPropagation();
        if (btn.classList.contains('is-active') && !detailView.hidden) {
          showRoot();
        } else {
          showDetail(btn);
        }
      });

      btn.querySelector('[data-millpoint-l2-close]')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showRoot();
      });
    });

    const resetIfClosed = () => {
      if (!disclosure?.classList.contains('is-open')) {
        showRoot();
      }
    };

    // Only watch the disclosure <li> for is-open changes — NOT transitionend on
    // .main-nav__child, because L2 hover/click CSS transitions bubble up and
    // would immediately reset the detail view after every click.
    if (disclosure) {
      new MutationObserver(resetIfClosed).observe(disclosure, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initMillpointMega);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
